module.exports = __webpack_public_path__ + "assets/img/video-icon.2b9cc43b.png";